/**
 * BrandRegisterContainer
 * --
 */
import React, { useState, useEffect } from 'react';
import BrandDetailPresenter from './BrandRegisterPresenter';
import MessageAlert from 'utils';
import { ShopInformationApi, ProductApi } from 'api';
import {
  PRODUCT_TYPE,
  PRODUCT_STATUS,
  APPLICATION_STATUS,
} from 'constants/ProductConstants';

/**----------------------------------------
 * [Component] 입점업체 상세: 컨테이너
 * ----------------------------------------
 */
const BrandRegisterContainer = ({ defaultShopId, onChangeShopInformation }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);
  const [shopId, setShopId] = useState(defaultShopId);
  const [shopInfomation, setShopInformation] = useState(null);
  const [productList, setProductList] = useState([]);

  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /**--------------------
   *
   * --------------------
   */
  // const handleChangeApplicationStatus = async () => {
  //   try{
  //   }catch(e){
  //     console.log('[BrandRegisterContainer][handleChangeApplicationStatus] Error: ', e);
  //     MessageAlert.error(e.message)
  //   }
  // }

  /**--------------------
   * 업체정보(shopInformation) 데이터 변경
   * --------------------
   */
  const handleChangeApplicationStatus = async (key, newStatus) => {
    setLoading(true);
    try {
      if (!newStatus) {
        MessageAlert.warning('값을 입력해주세요');
        setLoading(false);
        return;
      }

      // New data
      const newData = {
        shop_information_id: shopId,
        [key]: newStatus,
      };

      // API Call
      const { status, message, data } =
        await ShopInformationApi.updateShopInformation(newData);
      // 예외처리
      if (status !== 200) throw { message };
      // 상위 컴포넌트로 전달
      onChangeShopInformation(data);

      setTimeout(() => {
        // 메시지 처리
        if (key === 'application_status') {
          const name = shopInfomation.shop_information_name;
          const value = APPLICATION_STATUS[newStatus].title;
          const msg = `${name}의 심사상태가 [${value}]변경되었습니다`;

          MessageAlert.info(msg);
        } else {
          MessageAlert.info('피드백이 등록되었습니다');
        }
        // set state
        setShopInformation(data);
        setLoading(false);
      }, 1000);
    } catch (e) {
      setLoading(false);
      console.log(
        '[BrandRegisterContainer][handleChangeApplicationStatus] Error: ',
        e
      );
      MessageAlert.error(e.message);
    }
  };

  /**--------------------
   * 상품(product) 데이터 변경
   * --------------------
   */
  const handleChangeProduct = async (product_id, key, newStatus) => {
    setLoading(true);
    try {
      if (!newStatus) {
        MessageAlert.warning('값을 입력해주세요');
        setLoading(false);
        return;
      }
      const fid = productList.findIndex((p) => p.product_id === product_id);
      const newData = {
        product_id,
        [key]: newStatus,
      };
      // API Call
      const { status, message } = await ProductApi.updateProduct(newData);
      // 예외처리
      if (status !== 200) throw { message };

      setTimeout(() => {
        MessageAlert.info('변경되었습니다.');
        setLoading(false);
        setProductList((prev) => [
          ...prev.slice(0, fid),
          {
            ...prev[fid],
            ...newData,
          },
          ...prev.slice(fid + 1),
        ]);
      }, 1000);
    } catch (e) {
      setLoading(false);
      console.log('[BrandRegisterContainer][handleChangeProduct] Error: ', e);
      MessageAlert.error(e.message);
    }
  };

  /* ===== HOOKS ===== */
  /**--------------------
   * 입점업체 상세 조회
   * --------------------
   */
  useEffect(() => {
    const call = async () => {
      try {
        const { status, message, data } =
          await ShopInformationApi.getShopInformation(shopId);
        if (status !== 200) throw { message };
        setShopInformation(data);
      } catch (e) {
        MessageAlert.error(e.message);
      }
    };

    call();
  }, []);

  /**--------------------
   * 입점업체 상품 조회
   * --------------------
   */
  useEffect(() => {
    const call = async () => {
      try {
        const { status, message, data } = await ProductApi.getProducts({
          shop_information_id: shopId,
        });
        if (status !== 200) throw { message };
        setProductList(data);
      } catch (e) {
        MessageAlert.error(e.message);
      }
    };

    shopInfomation && call();
  }, [shopInfomation]);
  /* ===== RENDER ===== */
  return (
    <>
      <BrandDetailPresenter
        {...{
          loading,
          shopId,
          shopInfomation,
          productList,
          onChangeApplicationStatus: handleChangeApplicationStatus,
          onChangeProduct: handleChangeProduct,
        }}
      />
    </>
  );
};

BrandRegisterContainer.defaultProps = {
  defaultShopId: null,
  onChangeShopInformation: () => {},
};
export default BrandRegisterContainer;
